import { put, call } from "redux-saga/effects";
import { SagaIterator } from "redux-saga";
import { fetchFiltersVPO } from "../../api/api";
import { fetchFiltersSuccessVPO, fetchFiltersFailureVPO } from "./filters";

export function* handleFetchFiltersVPO(): SagaIterator {
  try {
    const data = yield call(fetchFiltersVPO);
    yield put(fetchFiltersSuccessVPO(data));
  } catch (error) {
    yield put(fetchFiltersFailureVPO(error.message));
  }
}
